import { render } from "./SelectCourse.vue?vue&type=template&id=79beb8d1&ts=true"
import script from "./SelectCourse.vue?vue&type=script&lang=ts"
export * from "./SelectCourse.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__